import styled, { css } from 'styled-components';

export const Header = styled.div`
  margin-bottom: 16px;
`;

export const ReviewsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Action = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  h1{
    margin: 0;
    margin-bottom: 8px
  }
`;

export const Comment = styled.div`
  margin-bottom: 8px;
  border-bottom: 1px solid #bdbdbd;
  padding-bottom: 6px;
`;

export const Info = styled.div`
  flex-wrap: wrap;
  display: flex;
  flex-direction: column;

  span {
    overflow-wrap: break-word;
    font-weight: bold;

    & + span{
      font-weight: normal;
    }
  }
`;

export const InfoContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 12px;
`;

export const InitialRegisterTitle = styled.span`
  font-size: 18px;
  font-weight: bold;
`;